package com.essntl.features.service.ui.allservice.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.service.ui.allservice.AllServiceState
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.spacing

@Composable
fun ServiceCategoryRow(
    state: AllServiceState,
    onCategorySelected: (String?) -> Unit,
    modifier: Modifier = Modifier,
) {
    val lazyListState = rememberLazyListState()

    // Todo: show scrollbar
    LazyRow(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(1.spacing),
        state = lazyListState,
        modifier = modifier,
    ) {
        item {
            ServiceCategoryItem(
                onClick = { onCategorySelected(null) },
                category = CategoryModel.all,
                isSelected = state.selectedCategoryId == null,
                getAllServiceCount = state.getAllServiceCount,
            )
        }

        if (state.getAllCategory.isLoading) {
            item {
                EsSpinner()
            }
        }

        items(
            state.getAllCategory.data.orEmpty(),
            key = { it.id },
        ) { category ->
            ServiceCategoryItem(
                onClick = { onCategorySelected(category.id) },
                category = category,
                isSelected = state.selectedCategoryId == category.id,
                getAllServiceCount = state.getAllServiceCount,
            )
        }
    }
}